import { useAnimationControls } from "framer-motion";
import { useCallback, useState } from "react";
import { MOTION } from "../../../theme/tokens";

const SWING = MOTION.SHAKE_OFFSET_PX;
/** Framer Motion times transitions in seconds; the motion tokens are in ms. */
const MS_PER_SECOND = 1000;

/**
 * The "fill this in first" nudge: a short side-to-side head-shake (transform only, so it never reflows), for a
 * required field the user tried to get past. Feed it to a `motion` element's controls.
 */
export const ATTENTION_SHAKE = {
	x: [0, -SWING, SWING, -SWING, SWING, 0],
	transition: { duration: MOTION.DURATION.SHAKE / MS_PER_SECOND, ease: "easeInOut" as const, times: [0, 0.2, 0.4, 0.6, 0.8, 1] },
};

/**
 * A required field's "you missed me" state: `flag()` marks it (draw the error frame while `flagged`) and shakes it
 * (`controls` on its `motion` wrapper); `clear()` drops the mark once it is filled in. The same nudge the Remove
 * staff dialog gives a missing reason.
 */
export const useAttentionShake = () => {
	const controls = useAnimationControls();
	const [flagged, setFlagged] = useState(false);
	const flag = useCallback(async () => {
		setFlagged(true);
		await controls.start(ATTENTION_SHAKE);
	}, [controls]);
	const clear = useCallback(() => setFlagged(false), []);
	return { controls, flagged, flag, clear };
};
